import { Alert, Input, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  ${typographyV2.bodyBase};
`;

export const StyledAlert = styled(Alert)`
  margin-top: 16px;
  width: 100%;
`;
